import store from '../store'
import { drive } from './google'
import { getCachedImage, setCachedImage } from './image_cache'

const getImageById = function(imageId) {
  return new Promise((resolve, reject) => {
    const imageRecord = store.getters.findImage(imageId)
    if(imageRecord) {
      resolve(imageRecord)
    } else {
      reject(new Error(`No image in index with ${imageId}`))
    }
  }).then(getImageByRecord)
}

const getImageByRecord = function({ id, md5, mimeType }) {
  return new Promise((resolve, reject) => {
    return getCachedImage(md5)
      .then((imageDataURL) => {
        if(imageDataURL) {
          resolve(imageDataURL)
        } else {
          return drive.downloadBinaryFile(id)
            .then((arrayBuffer) => {
              const bytes = new Uint8Array(arrayBuffer)
              let binary = ''
              for (let i = 0; i < bytes.byteLength; i++) {
                binary += String.fromCharCode(bytes[i])
              }
              const dataURL = `data:${mimeType};base64,${btoa(binary)}`
              return setCachedImage(md5, dataURL)
                .then(() => { resolve(dataURL) })
            })
            .catch(reject)
        }
      })
  }).then(getImageWithSrc)
}

const getImageByName = function(name) {
  return Bluebird.try(() => {
    // Get the active game's folder ID to scope the search
    const activeGame = store.getters.activeGame
    const gameFolderId = activeGame ? store.getters.getGameFolderId(activeGame) : null

    // Search all images matching the name
    const allMatches = store.getters.searchImages({ name })

    if (!allMatches || allMatches.length === 0) {
      throw new Error(`No image found with name: ${name}`)
    }

    // If we have a game context, prefer images within that game's folder hierarchy
    if (gameFolderId) {
      // Find images whose parents include the game folder or a subfolder of it
      const allFolders = store.getters.allFolders || []

      // Get all folder IDs that are children of the game folder
      const gameFolderIds = new Set([gameFolderId])
      allFolders.forEach(folder => {
        if (folder.parents && folder.parents.includes(gameFolderId)) {
          gameFolderIds.add(folder.id)
        }
      })

      // Find an image that lives within the game's folder hierarchy
      const scopedMatch = allMatches.find(img => {
        return img.parents && img.parents.some(p => gameFolderIds.has(p))
      })

      if (scopedMatch) {
        return getImageByRecord(scopedMatch)
      }
    }

    // Fall back to first match if no scoped match found
    return getImageByRecord(allMatches[0])
  })
}

const getImageWithSrc = function(imageSource) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = function() {
      resolve(image)
    }
    image.onerror = function(e) {
      reject(new Error(`Failed to load image: ${e.type || 'unknown error'}`))
    }
    image.src = imageSource
  })
}

export { getImageById, getImageByName }